/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompleteEmailRequest
 */
export interface ControlCompleteEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteEmailRequest
     */
    mfa_token: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteEmailRequest
     */
    oob_code: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteEmailRequest
     */
    binding_code: string;
}

/**
 * Check if a given object implements the ControlCompleteEmailRequest interface.
 */
export function instanceOfControlCompleteEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mfa_token" in value;
    isInstance = isInstance && "oob_code" in value;
    isInstance = isInstance && "binding_code" in value;

    return isInstance;
}

export function ControlCompleteEmailRequestFromJSON(json: any): ControlCompleteEmailRequest {
    return ControlCompleteEmailRequestFromJSONTyped(json, false);
}

export function ControlCompleteEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompleteEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mfa_token': json['mfa_token'],
        'oob_code': json['oob_code'],
        'binding_code': json['binding_code'],
    };
}

export function ControlCompleteEmailRequestToJSON(value?: ControlCompleteEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mfa_token': value.mfa_token,
        'oob_code': value.oob_code,
        'binding_code': value.binding_code,
    };
}

